import { render, staticRenderFns } from "./Confirmation.vue?vue&type=template&id=4a89933d&scoped=true&"
import script from "./Confirmation.ts?vue&type=script&lang=ts&"
export * from "./Confirmation.ts?vue&type=script&lang=ts&"
import style0 from "./Confirmation.vue?vue&type=style&index=0&id=4a89933d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a89933d",
  null
  
)

export default component.exports